import type { FieldStateMap } from '@/utils/field-state'
import type { CreditTab } from './types'

export type CreditDataTab = Exclude<CreditTab, 'documents'>

export const creditDataTabs: readonly CreditDataTab[] = ['income', 'expenses', 'assets', 'liabilities']

/** Which self-disclosure tab a required figure belongs to. */
const tabPerField: Record<string, CreditDataTab> = {
  income: 'income',
  expenses: 'expenses',
  assets: 'assets',
}

export const creditTabForField = (field: string): CreditDataTab => tabPerField[field.split('.')[0]] ?? 'income'

export const missingPerCreditTab = (fieldStates: FieldStateMap): Record<CreditDataTab, number> => {
  const counts = Object.fromEntries(creditDataTabs.map((tab) => [tab, 0])) as Record<CreditDataTab, number>

  Object.values(fieldStates)
    .filter((field) => field.state === 'missing')
    .forEach((field) => {
      counts[creditTabForField(field.key)] += 1
    })

  return counts
}
